module.exports = __webpack_public_path__ + "img/toplogo.a16e2d8b.png";